<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">اسم المجموعة:</label>
            <input type="text" v-model="name" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تخصيص الصلاحة على مناطق محددة:</label>
            <select v-model="allowedRegions" class="form-control" style="height: 150px;" multiple>
              <option v-for="reg in regionsList" :value="reg.id" :key="reg.id">{{ reg.name }}</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تخصيص التنبيهات على تطبيقات محددة:</label>
            <select v-model="notificationModels" class="form-control" style="height: 150px;" multiple>
              <option v-for="(val, key) in modelsList" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
        </div>

        <div v-for="(permission, indx) in permissionsList" class="row" :key="indx">
          <div class="col-12 mb-3 pb-2 border-bottom">
            <label for="" class="form-label"><i class="fa-solid fa-angle-left"></i> {{ permission.title }} :</label>
            <div class="row">
              <div v-for="(val, key) in permission.permissions" :key="key" class="col">
                <div class="form-check">
                  <input v-model="permissions" class="form-check-input" type="checkbox" :value="key" :id="`permission-check-${key}`">
                  <label class="form-check-label" :for="`permission-check-${key}`">{{ val }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'GroupsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    permissionsList: {
      type: Array,
      default: null,
    },
    modelsList: {
      type: Object,
      default: {},
    },
    regionsList: {
      type: Array,
      default: [],
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      name: '',
      permissions: [],
      allowedRegions: [],
      notificationModels: [],
    }
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(!this.name || this.name.trim() == ''){
        this.message = 'يرجى ادخال الاسم';
        this.errorNumber = 0;
        this.hasError = true;
        return false;
      }
      let payload = {
        name: this.name,
        permissions: JSON.stringify(this.permissions),
        allowedRegions: JSON.stringify(this.allowedRegions),
        notificationModels: JSON.stringify(this.notificationModels),
      }
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/groups/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/groups/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تمت إضافة بنجاح', 'success');
          this.$router.replace('/groups').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.permissions = this.dataRow.permissions;
      this.allowedRegions = this.dataRow.allowedRegions;
      this.notificationModels = this.dataRow.notificationModels;
    }
  }
}
</script>
